import interceptedAxios from '../../../utils/interceptedAxios'

export async function saveDefaultKpiConfig (
  defaultKpiRequest: any, assetTypeId: string,
  onSuccess: (successResponse: any, httpStatus: number) => void,
  onFailure: (errorMessage: any, httpStatus: number) => void
): Promise<void> {
  const url = `/asset-config-service/api/v1/udp/tiq/commands/configuration/assettype/${assetTypeId}/kpiconfig/default`
  interceptedAxios
    .put(url, defaultKpiRequest, { timeout: 15000 })
    .then((response) => {
      const responseData = response.data
      if (responseData.error === false) {
        if (responseData.data !== null && responseData.data !== undefined) {
          onSuccess(responseData.data, responseData.http_status)
        } else {
          onFailure(responseData.error, responseData.http_status)
        }
      } else {
        onFailure(responseData.error_message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
